function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHandcrafted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.23 512.23",
    style: {
      enableBackground: "new 0 0 512.23 512.23"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M409.929,129.501c-9.835,0-19.229-4.08-25.942-11.268l-42.336-45.327 c-3.661-3.92-7.901-7.256-12.571-9.892L234.959,9.887c-8.146-4.598-18.459-2.15-23.669,5.618h0 c-4.347,6.481-3.996,15.031,0.868,21.133l58.177,72.99l-48.077-4.609c-3.785-0.363-7.596-0.372-11.383-0.028L76.416,117.212 c-10.537,0.958-18.97,9.607-19.068,20.187c-0.104,11.322,8.989,20.528,20.254,20.622l-19.942-0.166 c-12.439-0.107-22.549,10.007-22.436,22.447l0,0c0.11,12.161,9.966,21.979,22.127,22.044l13.612,0.072 c-10.487-0.052-19.013,8.444-18.996,18.932l0,0c0.016,10.366,8.378,18.785,18.743,18.872l43.82,0.37 c-8.948,0.817-15.979,8.312-16.036,17.478v0c-0.058,9.251,7.031,16.979,16.252,17.718l170.363,13.652 c10.746,0.861,21.523-1.229,31.169-6.045l63.374-31.641c4.924-2.459,10.353-3.739,15.857-3.739H504.73V129.501H409.929z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB29F"
    },
    d: "M504.73,129.499v19.739H400.691c-10.144,0-19.838-4.208-26.754-11.623l-49.471-56.437 l-97.983-55.308c-5.837-3.298-12.743-3.088-18.219,0.04c-0.003-0.001-0.002-0.001-0.005-0.003 c-0.086-3.609,0.921-7.249,3.033-10.401c5.207-7.766,15.521-10.214,23.666-5.617l94.124,53.129 c4.67,2.636,8.909,5.972,12.57,9.891l42.339,45.327c6.706,7.186,16.101,11.263,25.935,11.263H504.73z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D07D62"
    },
    d: "M336.254,161.486c-1.854-8.546-6.49-15.772-12.752-20.935c-4.194-3.457-6.784-8.488-7.161-13.91 c-0.564-8.096-3.752-16.067-9.631-22.541c-5.879-6.474-13.507-10.414-21.511-11.754c-5.361-0.897-10.119-3.959-13.157-8.466 c-4.536-6.729-11.283-12.038-19.611-14.706c-8.328-2.667-16.904-2.266-24.506,0.576c-5.091,1.903-10.743,1.631-15.627-0.753 c-7.293-3.559-15.79-4.784-24.337-2.93c-8.546,1.854-15.772,6.49-20.934,12.752c-3.457,4.194-8.488,6.784-13.91,7.161 c-8.096,0.564-16.067,3.752-22.541,9.631c-6.474,5.879-10.414,13.507-11.754,21.51c-0.897,5.361-3.959,10.119-8.466,13.157 c-6.729,4.536-12.038,11.283-14.706,19.611c-2.667,8.328-2.265,16.904,0.576,24.506c1.903,5.091,1.631,10.743-0.753,15.627 c-3.559,7.293-4.784,15.79-2.93,24.337c1.854,8.546,6.49,15.772,12.752,20.934c4.194,3.457,6.784,8.488,7.162,13.91 c0.564,8.096,3.752,16.067,9.631,22.541c5.879,6.474,13.507,10.414,21.511,11.754c5.361,0.897,10.119,3.959,13.157,8.466 c4.536,6.729,11.283,12.038,19.611,14.706c8.328,2.667,16.904,2.266,24.506-0.576c5.091-1.903,10.743-1.631,15.628,0.753 c7.293,3.559,15.79,4.784,24.336,2.93c8.546-1.854,15.772-6.49,20.934-12.752c3.457-4.194,8.488-6.784,13.91-7.161 c8.096-0.564,16.067-3.752,22.541-9.631c6.474-5.879,10.414-13.507,11.754-21.511c0.897-5.361,3.959-10.119,8.466-13.157 c6.729-4.536,12.038-11.283,14.706-19.611c2.667-8.328,2.266-16.904-0.576-24.506c-1.903-5.091-1.631-10.743,0.753-15.627 C336.883,178.529,338.108,170.032,336.254,161.486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BE6A4F"
    },
    d: "M336.254,161.48c-1.854-8.545-6.492-15.772-12.751-20.934c-4.2-3.455-6.779-8.488-7.157-13.902 c-0.567-8.098-3.76-16.067-9.637-22.538c-5.88-6.482-13.504-10.419-21.506-11.765c-5.369-0.893-10.126-3.954-13.162-8.459 c-4.529-6.727-11.286-12.043-19.61-14.71c-8.324-2.668-16.908-2.257-24.503,0.581c-2.444,0.911-5.007,1.324-7.558,1.247 c38.16,14.386,68.479,47.25,77.771,90.076c13.719,63.235-23.277,125.67-83.722,144.899c0.709,0.251,1.402,0.541,2.08,0.869 c7.292,3.558,15.791,4.784,24.336,2.93c8.545-1.854,15.772-6.491,20.934-12.751c3.458-4.189,8.488-6.779,13.914-7.159 c8.087-0.565,16.07-3.748,22.54-9.626c6.47-5.877,10.417-13.515,11.751-21.515c0.896-5.358,3.957-10.115,8.473-13.153 c6.725-4.541,12.032-11.284,14.697-19.619c2.668-8.324,2.27-16.9-0.569-24.505c-1.9-5.085-1.639-10.733,0.752-15.618 C336.882,178.524,338.11,170.036,336.254,161.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCFC0"
    },
    d: "M306.511,357.404c-2.797-6.109-3.803-12.887-2.901-19.545l8.067-59.517 c1.352-9.974,1.169-20.096-0.543-30.015l-17.176-99.514c-1.591-9.218-10.01-15.657-19.323-14.78h0 c-7.769,0.732-14.169,6.412-15.82,14.039L239.078,239.3l-30.016-44.906l-98.861-100.85c-7.463-7.613-19.527-8.206-27.7-1.36h0 c-8.353,6.996-9.718,19.28-3.214,27.926l-0.017,0.005l-12.066-15.038c-7.785-9.703-22.014-11.136-31.577-3.18v0 c-9.35,7.777-10.721,21.621-3.078,31.082l7.081,8.765l-0.079,0.124c-6.796-6.594-17.615-7.192-25.126-1.038h0 c-8.019,6.569-9.251,18.371-2.762,26.454l27.431,34.175c-6.292-6.414-16.545-7.119-23.681-1.366v0 c-7.202,5.806-8.704,16.185-3.444,23.795l97.182,140.59c6.13,8.868,14.566,15.894,24.396,20.318l52.627,23.687 c8.299,3.735,14.846,10.515,18.289,18.94l31.259,76.48l138.211,0.755L306.511,357.404z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB29F"
    },
    d: "M373.936,504.66l-22.707-0.12l-66.901-146.135c-2.798-6.116-3.808-12.893-2.898-19.549 l8.065-59.515c1.349-9.974,1.169-20.098-0.55-30.013l-17.17-99.512c-0.829-4.797-3.498-8.835-7.186-11.483 c2.748-2.389,6.226-3.938,10.044-4.298c9.315-0.879,17.73,5.557,19.319,14.781l17.18,99.512c1.709,9.914,1.899,20.038,0.54,30.013 l-8.065,59.515c-0.9,6.656,0.11,13.432,2.898,19.549L373.936,504.66z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M267.222,28.098L234.959,9.887c-8.146-4.598-18.459-2.15-23.669,5.618l0,0c-4.347,6.481-3.996,15.031,0.868,21.133 l24.504,30.743"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M297.518,45.199l31.561,17.815c4.671,2.636,8.91,5.972,12.571,9.892l42.336,45.327c6.713,7.187,16.107,11.268,25.942,11.268 h94.801"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M504.73,248.016H395.509c-5.504,0-10.933,1.28-15.857,3.738l-63.374,31.642c-1.526,0.762-3.08,1.455-4.658,2.08"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M312.855,251.275c1.441-2.24,3.333-4.189,5.587-5.708c6.729-4.536,12.038-11.283,14.706-19.611 c2.667-8.328,2.266-16.904-0.576-24.506c-1.903-5.091-1.631-10.743,0.753-15.627c3.559-7.293,4.784-15.79,2.93-24.337 c-1.854-8.546-6.49-15.772-12.752-20.935c-4.194-3.457-6.784-8.488-7.161-13.91c-0.564-8.096-3.752-16.067-9.631-22.541 c-5.879-6.474-13.507-10.414-21.511-11.754c-5.361-0.897-10.119-3.959-13.157-8.466c-4.536-6.729-11.283-12.038-19.611-14.706 c-8.328-2.667-16.904-2.266-24.506,0.576c-5.091,1.903-10.743,1.631-15.627-0.753c-7.293-3.559-15.79-4.784-24.337-2.93 c-8.546,1.854-15.772,6.49-20.934,12.752c-3.457,4.194-8.488,6.784-13.91,7.161c-8.096,0.564-16.067,3.752-22.541,9.631 c-3.237,2.939-5.841,6.316-7.802,9.958"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M373.932,504.658l-67.422-147.254c-2.797-6.109-3.803-12.887-2.901-19.545l8.067-59.517c1.352-9.974,1.169-20.096-0.543-30.015 l-17.176-99.514c-1.591-9.218-10.01-15.657-19.323-14.78h0c-7.769,0.732-14.169,6.412-15.82,14.039L239.078,239.3 l-30.016-44.906l-98.861-100.85c-7.463-7.613-19.527-8.206-27.7-1.36l0,0c-8.521,7.137-9.77,19.777-2.812,28.444 l90.633,112.885"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M163.233,224.757l-96.029-119.68c-7.785-9.703-22.014-11.136-31.577-3.18l0,0c-9.35,7.777-10.721,21.621-3.078,31.082 l96.486,119.438"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M109.09,227.728l-67.983-84.155c-6.592-8.16-18.568-9.392-26.683-2.744l0,0c-8.019,6.569-9.251,18.37-2.762,26.454 l98.482,122.696"
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 225.519,478.942 235.721,503.903 235.98,504.457 \t\t\t\t\t"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M82.232,254.529l-42.015-51.811c-6.132-7.562-17.226-8.736-24.806-2.626l0,0c-7.202,5.806-8.704,16.186-3.444,23.795 l97.182,140.59c6.13,8.868,14.566,15.894,24.396,20.318l52.627,23.687c8.299,3.735,14.846,10.515,18.289,18.94l7.989,19.546"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHandcrafted);
export default __webpack_public_path__ + "static/media/handcrafted.2f79e156b17815c0865579caf3dc1a2a.svg";
export { ForwardRef as ReactComponent };